// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__56qDa","title":"AfterImages90_title__2Bas8","images":"AfterImages90_images__e-k2_"};